import React, { lazy, Suspense, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import MaterialRoutes from './material_design/routes';
import ThemeCustomization from './material_design/themes';

import Loader from "./components/Loader/Loader";
import "./App.scss";
import { hideLoader } from "./helpers/utils";
import { getAppEngagement, logoutUser, restoreUser } from "./redux/actions/userAction.js";
import { postRequest } from "./helpers/request.js";
// import AuthLayout from "./components/AuthLayout/AuthLayout";
import LinearProgress from '@mui/material/LinearProgress';

// Comment to verify SVN is working fine

// const Signup = lazy(() => import("./pages/Signup/Signup"));
// const Login = lazy(() => import("./pages/Login/Login"));
// const ForgotPassword = lazy(() => import("./pages/ForgotPassword/ForgotPassword"));
// const EmailVerifier = lazy(() => import("./pages/EmailVerifier/EmailVerifier"));
// const Home = lazy(() => import("./pages/Home/Home"));

// const Presentation = lazy(() => import("./pages/Presentation/Presentation"));
// const KeyMessage = lazy(() => import("./pages/KeyMessage/KeyMessage"));
// const Editor = lazy(() => import("./pages/Editor/Editor"));

// const Template = lazy(() => import("./pages/Template/Template"));
// const TemplateEditor = lazy(() => import("./pages/TemplateEditor/TemplateEditor"));

// const Imports = lazy(() => import("./pages/Imports/Imports"));
// const ImportKMs = lazy(() => import("./pages/ImportKMs/ImportKMs"));
// const ImportEditor = lazy(() => import("./pages/ImportEditor/ImportEditor"));

// const Emailer = lazy(() => import("./pages/Emailer/Emailer"));
// const EmailerEditor = lazy(() => import("./pages/EmailerEditor/EmailerEditor"));
// const Suggestion = lazy(() => import("./pages/Suggestion/Suggestion"));
//Added for changing user role and status
// const Settings = lazy(() => import("./pages/Settings/Settings"));

// const ComponentSetting = lazy(() => import("./pages/Component/Component.jsx"));
// const ComponentEditor = lazy(() => import("./pages/ComponentEditor/ComponentEditor.jsx"));
// const CodeEditor = lazy(() => import("./pages/CodeEditor/CodeEditor"));
// const Comparison = lazy(() => import("./pages/Comparison/Comparison.jsx"));

function App() {
  const userStore = useSelector((state) => state.userStore);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      if (userStore.token || userStore.refreshToken) {
        const { data } = await postRequest(
          `user/verify-token`,
          { validation: true },
          {
            headers: {
              "x-access-token": localStorage.getItem("token"),
              "x-refresh-token": localStorage.getItem("refreshToken"),
              changeOrigin: true,
            },
          }
        );

        // await new Promise((resolve) => setTimeout(resolve, 5000));

        if (!data.isSuccess) {
          await logoutUser()(dispatch);
        } else {
          await restoreUser(data)(dispatch);
        }
      }
    })();
  }, [userStore.token, userStore.refreshToken]);

  useEffect(() => {
    getAppEngagement()(dispatch);
  }, []);

  let routes;

  hideLoader();
  routes = (
    <>
      <MaterialRoutes isAuthenticated={userStore.token} >
      </MaterialRoutes>
    </>
  );
  if (userStore.token) {
    hideLoader();
  }

  return <ThemeCustomization><Suspense fallback={<LinearProgress />}>{routes}</Suspense></ThemeCustomization>;
}

export default App;
